export interface ProfileState {
    data: any;
  }
  
  export const initialProfileState: ProfileState = {
    data: null
  };